import { BackButton } from '../atoms'
import { capitalizeFirstLetter } from '@/helpers'
import { useUserLanguage } from '@/customHooks'
import { AddressProps } from '@/custom-types'

type PropertyTopBarProps = {
  name: string | undefined,
  address: AddressProps | undefined,
}

const textsData = {
  en: {
    userNameNoData: "No name available",
    addressNoData: "No address available",
  },
  es: {
    userNameNoData: "Nombre no disponible",
    addressNoData: "Dirección no disponible",
  },
}

export const PropertyTopBar = ({ name, address }: PropertyTopBarProps) => {
  const userLanguage = useUserLanguage();
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  const userName = (() => {
    return (
      name
        ? <h2 className="my-1.5 text-xl font-semibold">{capitalizeFirstLetter(name)}</h2>
        : <h2 className="my-1.5 text-xl font-semibold">{texts.userNameNoData}</h2>
    )
  })()

  const propertyAddress = (() => {
    return (
      address
        ? <p className="my-1.5 text-sm">{`${address.buildingNumber} ${address.street}, ${address.city}. ${address.state}. ${address.zipCode}`}</p>
        : <p className="my-1.5 text-sm">{texts.addressNoData}</p>
    )
  })()
  return (
    <div className="flex items-center gap-4 px-4 py-2 sm:px-6 lg:px-8">
      <div className="shrink-0">
        <BackButton />
      </div>
      <div className="min-w-0 flex-1">
        {userName}
        {propertyAddress}
      </div>
    </div>
  )
}
